import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import "swiper/css";

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="testimonial-card">
      <div className="top-content">
        <div className="testi-rating">
          {[...Array(5)].map((_, index) => (
            <FontAwesomeIcon key={index} icon={faStar} />
          ))}
        </div>
        <div className="feedback">{testimonial.feedback}</div>
      </div>
      {/* <div className="bottom-content">
        <div className="testi-image">
          <div className="user-image">
            <img src={testimonial.userImage} alt="User" />
          </div>
          <div className="brand-image">
            <img src={testimonial.brandImage} alt="Brand" />
          </div>
        </div>
        <div className="testi-userinfo">
          <div className="name text-high-emphasis">{testimonial.name}</div>
          <div className="position text-med-emphasis">
            {testimonial.position}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TestimonialCard;
